import { defineContent, type DefinedContent } from '@post-office/define-content';

import { FormattedMessage } from 'react-intl';

import { type JSX } from 'react/jsx-runtime';

export const HAMS_PRODUCT_ID = 'loom';

export const PRODUCT_NAME = 'Loom';

export const CCP_PRODUCT_ID = '7683a73e-423d-41a1-b43f-d497656f8b5d';

export const registeredContent: DefinedContent<['appName', 'description']> = defineContent({
	default: {
		appName: {
			id: 'growth.recommendation-loom.app-switcher-discovery-section.app-name',
			defaultMessage: 'Loom',
			description: 'Product name for the Loom recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-loom.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Record and share videos easily',
			role: 'description',
		},
	},
});

export const PRODUCT_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.default.description} />
);
